export const MAIL_TIMER = 18000;
